/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Address,
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
} from './';

/**
 * 
 * @export
 * @interface CreateWorkspace
 */
export interface CreateWorkspace {
    /**
     * 
     * @type {Address}
     * @memberof CreateWorkspace
     */
    address?: Address;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkspace
     */
    name?: string;
    /**
     * The preferred locale used for communication, in BCP 47 format.
     * @type {string}
     * @memberof CreateWorkspace
     */
    locale?: string;
    /**
     * Google Place ID of the workspace address.
     * @type {string}
     * @memberof CreateWorkspace
     */
    googlePlaceId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkspace
     */
    timezone?: string;
}

export function CreateWorkspaceFromJSON(json: any): CreateWorkspace {
    return CreateWorkspaceFromJSONTyped(json, false);
}

export function CreateWorkspaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateWorkspace {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': !exists(json, 'address') ? undefined : AddressFromJSON(json['address']),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'locale': !exists(json, 'locale') ? undefined : json['locale'],
        'googlePlaceId': json['googlePlaceId'],
        'timezone': !exists(json, 'timezone') ? undefined : json['timezone'],
    };
}

export function CreateWorkspaceToJSON(value?: CreateWorkspace | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': AddressToJSON(value.address),
        'name': value.name,
        'locale': value.locale,
        'googlePlaceId': value.googlePlaceId,
        'timezone': value.timezone,
    };
}


